import { getRouterSelectors } from "@ngrx/router-store";

const routerSelectors = getRouterSelectors();

export const { selectUrl, selectRouteData } = routerSelectors;
export const selectQueryParams = <T>() =>
  routerSelectors.selectQueryParams as T;
